import { connect } from "react-redux";

import DistributionListView from "./DistributionListView.jsx";

import { fetchReportSummary } from "src/legacy/redux/actions/home.jsx";
import hasAccess from "../../../services/hasAccess.jsx";
import withUseHooks from "src/legacy/components/withUseHooks.jsx";


const mapStateToProps = (state, ownProps) => {
  
  var contactListId = ownProps.params.id;
  var contactList = state.legacyRootReducer.contactLists.contactList[contactListId];
  console.log(contactList);

  return {
    globalContactsEnabled: state.accounts.item.globalContactEnabled,
    loading: state.legacyRootReducer.rolodex.loading || state.legacyRootReducer.contactLists.loading,
    contactList: contactList && contactList.item ? contactList.item : null
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReportSummary: () => {
      return dispatch(fetchReportSummary());
    },
  };
};

const DistributionListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DistributionListView);

export default hasAccess(withUseHooks(DistributionListContainer), 'distribution-lists');
